import { render, staticRenderFns } from "./Anas.vue?vue&type=template&id=0b45cc58&scoped=true"
import script from "./Anas.vue?vue&type=script&lang=js"
export * from "./Anas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45cc58",
  null
  
)

export default component.exports